import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const Button = styled.button.attrs({ type: 'button' })<{
  direction: 'left' | 'right';
  disabled: boolean;
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => direction}: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ disabled }) => disabled ? 0.4 : 1};
  transition: all 0.2s ease;
  z-index: 10;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:active:not(:disabled) {
    transform: translateY(-50%) scale(0.95);
  }

  .anticon {
    font-size: 16px;
    color: #000;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    width: 36px;
    height: 36px;
    ${({ direction }) => direction}: 16px;
    
    .anticon {
      font-size: 16px;
    }
  }
`;